/** Client-local deadlines shared by the canvas and DOM arrival renderers. */
const arrivals = new Map<string, number>();

/** The first new object is ready now; subsequent objects wait one gap each. */
export function scheduleCanvasArrivals(
  ids: readonly string[],
  gapMs: number,
  now: number
): void {
  // A due deadline no longer delays anything: drop those never drawn since.
  for (const [id, deadline] of arrivals)
    if (deadline <= now) arrivals.delete(id);
  ids.forEach((id, index) => arrivals.set(id, now + index * gapMs));
}

/** The first read at or after a deadline consumes it. Unknown objects never wait. */
export function canvasArrivalDelay(id: string, now: number): number {
  const deadline = arrivals.get(id);
  if (deadline === undefined) return 0;
  const delay = Math.max(0, deadline - now);
  if (delay === 0) arrivals.delete(id);
  return delay;
}
